import { addSeconds, addMinutes } from 'helpers/dates';

export const removeStorage = key => {
    localStorage.removeItem(key);
};

export const setStorage = (key, value) => {
    const object = { value, expiry: addMinutes(new Date(), 60) };
    localStorage.setItem(key, JSON.stringify(object));
};

export const getStorage = key => {
    const json = localStorage.getItem(key);
    try {
        const object = JSON.parse(json);
        if (new Date(object.expiry) < new Date()) {
            removeStorage(key);
            return null;
        } else {
            return object.value;
        }
    } catch {
        return '';
    }
};
